/**
 * @Date:   2017-12-27T08:53:24+08:00
 * @Last modified time: 2018-01-17T13:51:16+08:00
 */

import Vue from "vue";
import Router from "vue-router";

import IndexFrame from "@/components/common/IndexFrame";
import ContainerWithMenu from "@/components/common/ContainerWithMenu";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      component: IndexFrame,
      children: [
        {
          path: "",
          redirect: "/list",
          component: ContainerWithMenu,
          children: [
            {
              path: "list",
              name: "list",
              component: () => ({
                component: import("@/components/list/index.vue")
              })
            },
            {
              path: "list/deviceDetail/:id",
              name: "deviceDetail",
              component: () => ({
                component: import("@/components/list/deviceDetail.vue")
              })
            },
            {
              path: "list/recordDetail",
              name: "recordDetail",
              component: () => ({
                component: import("@/components/list/recordDetail.vue")
              })
            },
            {
              path: "list/userDetail/:deviceId",
              name: "userDetail",
              component: () => ({
                component: import("@/components/list/userDetail.vue")
              })
            },
            {
              path: "list/alertDetail/:deviceId",
              name: "alertDetail",
              component: () => ({
                component: import("@/components/list/alertDetail.vue")
              })
            },
            {
              path: "overview",
              name: "overview",
              component: () => ({
                component: import("@/components/overview/index.vue")
              })
            },
            {
              path: "product",
              name: "product",
              component: () => ({
                component: import("@/components/product/index.vue")
              })
            },
            {
              path: "product/add",
              name: "productAdd",
              component: () => ({
                component: import("@/components/product/add.vue")
              })
            },
            {
              path: "product/edit/:id",
              name: "productEdit",
              component: () => ({
                component: import("@/components/product/add.vue")
              })
            },
            {
              path: "factory",
              name: "factory",
              component: () => ({
                component: import("@/components/lockFactory/factory.vue")
              })
            },
            {
              path: "factory/add",
              name: "factoryAdd",
              component: () => ({
                component: import("@/components/lockFactory/add.vue")
              })
            },
            {
              path: "factory/modify/:factoryId",
              name: "factoryModify",
              component: () => ({
                component: import("@/components/lockFactory/modify.vue")
              })
            },

            {
              path: "firmware",
              name: "firmware",
              component: () => ({
                component: import("@/components/firmware/firmware.vue")
              })
            },
            {
              path: "firmware/add",
              name: "firmwareAdd",
              component: () => ({
                component: import("@/components/firmware/firmwareAdd.vue")
              })
            },
            {
              path: "firmware/edit/:firmwareInfo",
              name: "firmwareEdit",
              component: () => ({
                component: import("@/components/firmware/firmwareAdd.vue")
              })
            }
          ]
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: () => ({
        component: import("@/components/user/Login")
      })
    },
    {
      path: "/adminLogin",
      name: "adminLogin",
      component: () => ({
        component: import("@/components/user/adminLogin")
      })
    },
    {
      path: "/factoryLogin",
      name: "factoryLogin",
      component: () => ({
        component: import("@/components/user/factoryLogin")
      })
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js